import React from 'react';
import { observer } from 'mobx-react';
import { FormItem, FormListItem, IconTextButton, Space, Icon, IconButton, TimePicker, ITimePickerProps } from 'ui-lib';
import componentCss from './component.css';
import { IDeviceGroupOutOfServiceSettingsProps } from '../../../dto/device-group-dto';
import { formatDate , DATE_TIME_FORMAT , isValidShortTime } from 'common-utils/date-utils';

export interface IOutOfServiceSettingsDisplayProps {
    startTime: string;
    endTime: string;
}

export interface IOutOfServiceSettings {
    code: string;
    className?: string;
    label?: string;
    initialValue: IOutOfServiceSettingsDisplayProps[];
    readonly?: boolean;
}


export function getDisplayOutOfServiceSettings(
    outOfServiceSettings: IDeviceGroupOutOfServiceSettingsProps,
): IOutOfServiceSettingsDisplayProps[] {
    return outOfServiceSettings?.outOfServiceWindows?.map(item => ({
        startTime: isValidShortTime(item.startTime) ? item.startTime : formatDate(item.startTime, DATE_TIME_FORMAT.SHORT_TIME),
        endTime: isValidShortTime(item.endTime) ? item.endTime : formatDate(item.endTime, DATE_TIME_FORMAT.SHORT_TIME),
    })) ?? [];
}

const icons = {
    plus: 'file-plus',
    minimize: 'close',
};
export interface IOutOfServiceFormItemProps extends Omit<ITimePickerProps, 'timeStringValue' | 'onChange'> {
    readonly?: boolean;
    label?: string;
    initialValue: IOutOfServiceSettingsDisplayProps[];
    name?: string;
}

export const OutOfServiceFormItem = (props: IOutOfServiceFormItemProps) => {
    return (
        <FormListItem
            code={props.code}
            label={props.label}
            labelCol={{ span: 5 }}
            labelAlign={'right'}
            colon={false}
            formListProps={{
                initialValue: props.initialValue,
                name: 'deviceGroupOutOfServiceSettings',
                children: (fields, { add, remove }) => (
                    <React.Fragment>
                        {fields.map(({ key, name, ...restField }) => (
                            <Space key={key} className={props.className} align='baseline'>
                                <FormItem
                                    code={'startTime'}
                                    {...restField}
                                    name={[name, 'startTime']}
                                    rules={[{ required: true, message: 'Start time required' }]}
                                    child={<TimePicker code='startTime' format='HH:mm' timeStringValue={(props.initialValue[key]?.startTime)} />}
                                />
                                <FormItem
                                    code={'endTime'}
                                    {...restField}
                                    name={[name, 'endTime']}
                                    rules={[{ required: true, message: 'End time required' }]}
                                    child={<TimePicker code='endTime' format='HH:mm' timeStringValue={props.initialValue[key]?.endTime} />}
                                />
                                <IconButton
                                    iconName={icons.minimize as any}
                                    iconClassName={componentCss['out-of-service-window-remove-button']}
                                    size='SMALL'
                                    onClick={() => remove(name)}
                                    disabled={props.readonly}
                                />
                            </Space>
                        ))}
                        <FormItem
                            code={'addOutOfServiceButton'}
                            child={
                                <IconTextButton
                                    onClick={() => add()}
                                    iconName={icons.plus as any}
                                    disabled={props.readonly}
                                    key='addOutOfServiceWindow'
                                    label='Add Out Of Service Window'
                                    type='primary'
                                />
                            }
                        />
                    </React.Fragment>
                ),
            }}
        />
    );
};
